/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import useStyles from 'isomorphic-style-loader/useStyles';
import React from 'react';
import PropTypes from 'prop-types';

import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import Container from '@material-ui/core/Container';
import InteractiveStockChart from '../../components/InteractiveStockChart';
import s from './Stock.css';

const STOCK_INFO_QUERY = gql`
  query getStockInfo($stockcode: String!) {
    stock(code: $stockcode) {
      chineseName
      englishName
    }
  }
`;

export default function Stock({ code }) {
  // useStyles(s);

  let chineseName = '';
  let englishName = '';

  const { loading, error, data } = useQuery(STOCK_INFO_QUERY, {
    variables: { stockcode: code },
  });

  if (!loading && !error && data) {
    chineseName = data.stock[0].chineseName;
    englishName = data.stock[0].englishName;
  }

  return (
    <Container maxWidth="xl">
      <h1>
        {code} {chineseName} {englishName}
      </h1>
      <InteractiveStockChart stockcode={code} />
    </Container>
  );
}

Stock.propTypes = {
  code: PropTypes.string.isRequired,
};
